import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="rankfix-not-found grid min-h-full place-items-center px-4 py-20 text-center">
      <div>
        <p className="text-sm font-medium text-brand">404</p>
        <h1 className="mt-2 text-xl font-semibold text-ink">Page not found</h1>
        <p className="mt-1 text-sm text-ink-muted">
          The page you are looking for does not exist or has moved.
        </p>
        <Link
          to="/sites"
          className="mt-6 inline-flex rounded-md bg-brand px-3.5 py-2 text-sm font-medium text-white hover:bg-brand-hover"
        >
          Back to your websites
        </Link>
      </div>
    </div>
  );
}
